<template>
  <a-modal
    title="固定价"
    :width="1280"
    :visible="visible"
    @ok="() => { $emit('ok', { fixed_price_list: this.fixedPriceList, fixed_pricing_info: this.pointPriceInfo}) }"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="confirmLoading">
      <a-row :gutter="[16,16]" v-if="pointPriceInfo !== undefined && pointPriceInfo.price_type !== undefined && pointPriceInfo.price_type !== null">
        <a-col :span="24" v-if="contract">
          <a-divider orientation="left">货品基础数据 </a-divider>
          <a-col :span="8" v-if="contract.client">
            客户：<span class="important-content">{{ contract.client }}</span>
          </a-col>
          <a-col :span="8" v-if="contract.count">
            数量：<span class="important-content">{{ contract.count + '' }} {{ dictionaries.unit[contract.unit] }}</span>
          </a-col>
          <a-col :span="8" v-if="contract.shortage_rate">
            短装率：<span class="important-content">{{ contract.shortage_rate + '%' }} </span>
          </a-col>
          <a-col :span="8" v-if="contract.overloading_rate">
            溢装率：<span class="important-content">{{ contract.overloading_rate + '%' }} </span>
          </a-col>
        </a-col>
        <a-col :span="24" v-if="pointPriceInfo">
          <a-divider orientation="left">固定价基础数据</a-divider>
        </a-col>
        <a-col :span="8" v-if="pointPriceInfo.price_type.unit_price">
          单价：<span class="important-content">{{ pointPriceInfo.price_type.unit_price + '' }} {{ dictionaries.currency[pointPriceInfo.price_type.pricing_currency] }}</span>
        </a-col>
        <a-col :span="8" v-if="pointPriceInfo.price_type.is_tax_unit_price">
          单价是否含税：<span class="important-content">{{ pointPriceInfo.price_type.is_tax_unit_price? '是' : '否' }} </span>
        </a-col>
        <a-col :span="8">
          收款币种：<span class="important-content">{{ dictionaries.currency[pointPriceInfo.price_type.receive_pricing_currency] }}</span>
        </a-col>
        <a-col :span="8">
          汇率：<span class="important-content">{{ pointPriceInfo.price_type.exchange_rate}}</span>
        </a-col>
        <a-col :span="8">
          数量：<span class="important-content">{{ pointPriceInfo.price_type.pricing_count}}</span>
        </a-col>
        <a-col :span="8">
          合同金额：<span class="important-content">{{ pointPriceInfo.price_type.contract_amount}}</span>
        </a-col>
        <a-col :span="8">
          合同金额是否含税：<span class="important-content">{{ pointPriceInfo.price_type.is_tax_contract_amount ? '是' : '否' }}</span>
        </a-col>
        <a-col :span="24">
          <a-divider orientation="left">明细</a-divider>
        </a-col>
        <a-col :span="2" style="text-align: center">
          <a-button @click="triggerCreate">计价</a-button>
        </a-col>
        <a-col :span="24">
          <a-table
            style="width: 100%"
            v-if="fixedPriceList.length > 0 "
            :data-source="fixedPriceList"
            :columns="fixedPriceColumns"
            :pagination="false">
            <span slot="serial" slot-scope="text, record, index">
              {{ index + 1 }}
            </span>
            <template
              v-for="col in ['lock_price']"
              :slot="col"
              slot-scope="text, record"
            >
              <div :key="col">
                <a-input-number
                  v-if="record.editable"
                  style="margin: -5px 0"
                  :value="text"
                  :precision="4"
                  @change="e => handleChange(e, record.key, col)"
                />
                <template v-else>
                  {{ text }}
                </template>
              </div>
            </template>
            <template slot="action" slot-scope="text, record">
              <a v-if="record.lock_price_type === 3" @click="showLockPriceDetail(record)">明细</a>
              <a-divider v-if="record.lock_price_type === 3" type="vertical" />
              <a-popconfirm
                :title="deleteTitle(record)"
                @confirm="() => onDeleteItem(record)"
              >
                <a href="javascript:;">删除</a>
              </a-popconfirm>
              <a-divider v-if="record.lock_price_type === 3 && !record.editable" type="vertical" />
              <a v-if="record.lock_price_type === 3 && !record.editable" @click="editLockPrice(record.key)">编辑</a>
              <span v-if="record.editable">
                <a-divider type="vertical" />
                <a @click="() => saveLockPrice(record.key)">保存</a>
                <a-divider type="vertical" />
                <a-popconfirm title="确定取消吗?" @confirm="() => cancelLockPrice(record.key)">
                  <a>取消</a>
                </a-popconfirm>
              </span>
            </template>
          </a-table>
        </a-col>
      </a-row>
      <component
        :ref="currentComponent"
        @cancel="handleAddCancel"
        @ok="handleOk"
        :record="mdl"
        :is="currentComponent"
        :visible="createContractVisible"
        v-if="createContractVisible"
        :loading="confirmLoading"
        :model="mdl" />
    </a-spin>
  </a-modal>
</template>

<script>
import { Dictionaries } from '@/common/AllConstant'
import {
  sell_contract_list,
  sell_contract_fixed_price_details_delete,
  trade_sell_contract_fixed_pricing_details
} from '@/api/trade_sell_contract'
import FixedPriceApplyCreateForm from './FixedPriceApplyCreateForm'
import debounce from 'lodash/debounce'
import { project_list } from '@/api/trade_project'

export default {
  name: 'PointPriceApply',
  components: {
    FixedPriceApplyCreateForm
  },
  props: {
    contract: {
      type: Object,
      default: () => {
        return null
      }
    },
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      required: false
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      }
    }
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    return {
      form: this.$form.createForm(this),
      dictionaries: Dictionaries,
      pointPriceInfo: undefined,
      currentComponent: '',
      createType: 0,
      mdl: {},
      projectFetching: false,
      sellContractFetching: false,
      projectList: [],
      selectedProjectId: undefined,
      selectedProject: undefined,
      sellContractList: [],
      isServerData: false,
      lockPriceDetailVisible: false,
      createContractVisible: false,
      confirmLoading: false,
      pointPriceDetailList: [],
      fixedPriceList: [],
      cachefixedPriceList: [],
      editingKey: '',
      fixedPriceColumns: [
        {
          title: '序号',
          width: 80,
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '计价日期',
          dataIndex: 'lock_price_date',
          width: 180,
          align: 'center'
        },
        {
          title: '锁价数量',
          dataIndex: 'lock_count',
          width: 120,
          align: 'center',
          ellipsis: true
        },
        {
          title: '锁价价格',
          dataIndex: 'lock_price',
          width: 150,
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'lock_price' }
        },
        {
          width: 180,
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  computed: {
    deleteTitle () {
      return (record) => {
        return record.id > 0 ? '删除后数据不会恢复，确定删除吗？' : '确定删除吗？'
      }
    }
  },
  mounted () {
    this.loadPointPrice()
  },
  methods: {
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    handleProjectSearch (value) {
      this.projectFetching = true
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      }).finally(() => {
        this.projectFetching = false
      })
    },
    handleProjectChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleProjectSearch(value)
      } else {
        this.selectedProjectId = value
        this.selectedProject = this.projectList.filter(item => item.id === this.selectedProjectId)[0]
        this.sellContractList = []
        this.form.setFieldsValue({
          sell_contract_id: undefined
        })
        this.form.setFieldsValue({
          client_ids: undefined
        })
        this.handleSellContractSearch()
      }
    },
    handleSellContractChange (value) {
      if (value !== undefined) {
        this.contract = this.sellContractList.filter(item => item.id === value)[0]
        console.log('合同信息', this.contract)
        this.loadPointPrice()
      }
    },
    handleSellContractSearch () {
      if (this.selectedProjectId === undefined) {
        return
      }
      this.sellContractFetching = true
      sell_contract_list({ project_id: this.selectedProjectId, is_expired: false, page: 1, page_size: 999 }).then((res) => {
        const result = res.data.entries || []
        this.sellContractList = result
      }).finally(() => {
        this.sellContractFetching = false
      })
    },
    loadPointPrice () {
      this.confirmLoading = true
      sell_contract_list({ id: this.contract.id }).then(res => {
        if (res.code === 1000 && res.data.entries !== undefined && res.data.entries.length > 0) {
          this.pointPriceInfo = res.data.entries[0]
          this.loadFixedPriceDetail()
        }
      }).finally(() => {
        this.confirmLoading = false
      })
    },
    loadFixedPriceDetail () {
      if (this.pointPriceInfo === undefined || this.pointPriceInfo.price_type === undefined || this.pointPriceInfo.price_type === null) {
        return
      }
      trade_sell_contract_fixed_pricing_details({ fixed_pricing_id: this.pointPriceInfo.price_type.id }).then(res => {
        if (res.code === 1000 && res.data.entries !== undefined && res.data.entries.length > 0) {
          this.fixedPriceList = res.data.entries
          if (this.fixedPriceList) {
            this.fixedPriceList = this.fixedPriceList.map((item, index) => {
              item['key'] = Math.random() * 100000 + index
              item['editable'] = false
              return item
            })
            this.cachefixedPriceList = [...this.fixedPriceList]
            this.isServerData = true
          }
        }
      })
    },
    tasCreate () {
      this.createType = 1
      this.currentComponent = 'FixedPriceApplyCreateForm'
      this.mdl['type'] = this.createType
      this.createContractVisible = true
    },
    triggerCreate () {
      this.createType = 2
      this.currentComponent = 'FixedPriceApplyCreateForm'
      this.mdl['type'] = this.createType
      this.createContractVisible = true
    },
    naturalPricingCreate () {
      this.createType = 3
      this.currentComponent = 'PointPriceApplyNaturePriceCreateForm'
      this.mdl['type'] = this.createType
      this.createContractVisible = true
    },
    handleAddCancel () {
      this.createContractVisible = false
      this.createType = 0
      this.mdl = {}
    },
    onDeleteItem (record) {
      const key = record.key
      const dataSource = [...this.fixedPriceList]
      if (record.id) {
        const deleteDataList = dataSource.filter(item => item.key === key)
        if (deleteDataList !== undefined && deleteDataList.length > 0) {
          const deleteData = deleteDataList[0]
          if (deleteData.id) {
            sell_contract_fixed_price_details_delete(deleteData.id).then(res => {
              if (res.code === 1000) {
                this.fixedPriceList = dataSource.filter(item => item.key !== key)
              }
            })
          } else {
            const dataSource = [...this.fixedPriceList]
            this.fixedPriceList = dataSource.filter(item => item.key !== key)
          }
        }
      } else {
        const dataSource = [...this.fixedPriceList]
        this.fixedPriceList = dataSource.filter(item => item.key !== key)
      }
    },
    editLockPrice (key) {
      const newData = [...this.fixedPriceList]
      const target = newData.find(item => key === item.key)
      this.editingKey = key
      if (target) {
        target.editable = true
        this.fixedPriceList = newData
      }
    },
    saveLockPrice (key) {
      const newData = [...this.fixedPriceList]
      const newCachefixedPriceList = [...this.cachefixedPriceList]
      const target = newData.find(item => key === item.key)
      const targetCache = newCachefixedPriceList.find(item => key === item.key)
      if (target && targetCache) {
        delete target.editable
        this.fixedPriceList = newData
        Object.assign(targetCache, target)
        this.cachefixedPriceList = newCachefixedPriceList
      }
      this.editingKey = ''
    },
    cancelLockPrice (key) {
      const newData = [...this.fixedPriceList]
      const target = newData.find(item => key === item.key)
      this.editingKey = ''
      if (target) {
        Object.assign(target, this.cachefixedPriceList.find(item => key === item.key))
        delete target.editable
        this.fixedPriceList = newData
      }
    },
    handleChange (value, key, column) {
      const newData = [...this.fixedPriceList]
      const target = newData.find(item => key === item.key)
      if (target) {
        target[column] = value
        this.fixedPriceList = newData
      }
    },
    showLockPriceDetail (record) {
      this.pointPriceDetailList = record.nature_price_list
      this.lockPriceDetailVisible = true
    },
    checkLockDate (values) {
      const futures_contract_lock_date_list = this.pointPriceInfo.price_type.futures_contract_list.map(item => item.lock_up_date)
      console.log('===', futures_contract_lock_date_list)
      const lock_date = new Date(values['lock_date'])
      for (const futuresContractLockDate of futures_contract_lock_date_list) {
        const contractDate = new Date(futuresContractLockDate)
        console.log(contractDate, lock_date, contractDate > lock_date)
        if (contractDate > lock_date) {
          return true
        }
      }
      return false
    },
    checkLockCount (values) {
      const lock_count = parseFloat(values['lock_count'])
      const locked_count = this.fixedPriceList.reduce((total, item) => {
        const val = parseFloat(item['lock_count'])
        return total + (isNaN(val) ? 0 : val)
      }, 0)
      const contract_max_count = this.contract.count * (1 + parseFloat(this.contract.overloading_rate)) - locked_count
      if (lock_count > contract_max_count) {
        return false
      }
      return true
    },
    handleOk () {
      const form = this.$refs[this.currentComponent].form
      form.validateFields((errors, values) => {
        if (!errors) {
          const date = new Date()
          const key = date.getHours() + '' + date.getMinutes() + '' + date.getSeconds()
          this.fixedPriceList.push({ ...values, key: key, editable: false })
          this.cachefixedPriceList = this.fixedPriceList.map(item => ({ ...item }))
          this.createContractVisible = false
        } else {
          this.confirmLoading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.desc {
  padding-right: 20px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
}
.row_item {
  border-bottom: 1px solid #eeeeee;
  padding: 10px 20px;
  background-color: #f7f7f7;
  margin-top: 5px;
  border-radius: 10px;
}
.ope>span:hover {
  color: #2a99ff;
  cursor: pointer;
}
.ope>span:first-child {
  padding-left: 0px;
  height: 40px;
  line-height: 40px;
}
.ope>span:not(:first-child) {
  padding-left: 20px;
  height: 40px;
  line-height: 40px;
}
.content {
  /*color: #00A0E9;*/
  /*font-weight: bolder*/
}
.none {
  color: #333333;
}
.waiting {
  color: yellowgreen;
}
.pass {
  color: green;
}
.un_pass {
  color: red;
}
.space {
  margin-top: 5px;
  overflow-x: auto;
}
.important-content {
  font-weight: bold;
}
</style>
